/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPlanDefinitionVersion extends models.BaseDefinitionVersion {
    getFixupPrototypeFunction() { return BillingPlanDefinitionVersion.fixupPrototype; }

    static newInstance(model: Partial<BillingPlanDefinitionVersion>): BillingPlanDefinitionVersion {
        let obj = Object.assign(new BillingPlanDefinitionVersion(), model);
        BillingPlanDefinitionVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPlanDefinitionVersion>): BillingPlanDefinitionVersion {
        if (!model) return null;
        return BillingPlanDefinitionVersion.newInstance(<BillingPlanDefinitionVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPlanDefinitionVersion) {
        if (!obj) return;

        models.BillingPlanDefinitionVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPlanDefinitionVersion): boolean {
        if (models.BaseDefinitionVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingPlanDefinitionVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.details) {
            models.BillingPlanConfiguration.fixupPrototype(this.details);
        }
        if (this.statuses) {
            for (let val of this.statuses) {
                models.BillingPlanSyncStatus.fixupPrototype(val);
            }
        }
    }

    /**
     * Details of the version
     */
    details: models.BillingPlanConfiguration;

    /**
     * Billing Plan Execution Status. This field is used to indicate the completion status of the billing plan execution.
     */
    status: models.BillingPlanExecutionStatus;

    /**
     * Status by service account
     */
    statuses: Array<models.BillingPlanSyncStatus>;

    /**
     * Created by
     */
    created_by: string;

    /**
     * Updated by
     */
    updated_by: string;

}
